import React from "react";
import styled from "styled-components";
import { get as lodashGet } from "lodash";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";

import CouponListItem from "src/components/Coupon/CouponListItem";

const Wrapper = styled.div`
  .no_data {
    margin: 40px 0 50px;
    font-size: 20px;
    line-height: 1.3;
  }
  .Mui-disabled {
    pointer-events: initial !important;
    cursor: pointer !important;
  }
`;

const ChangedCouponList = ({ getCouponById }) => {
  const couponsList = useSelector((state) => state.ajax.exchangedCoupon);
  const formatCouponList = lodashGet(couponsList, ["data", "rows"], []);

  return (
    <Wrapper>
      {formatCouponList.length < 1 ? (
        <Typography className="no_data" color="primary">
          請至未兌換頁面兌換
        </Typography>
      ) : (
        formatCouponList.map((coupon) => {
          return (
            <CouponListItem
              getCouponById={getCouponById}
              key={coupon.id}
              isExchanged
              {...coupon}
            />
          );
        })
      )}
    </Wrapper>
  );
};

export default ChangedCouponList;
